"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorSwatch = void 0;
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var theme_1 = require("../../../mantine-theme/src");
var ColorSwatch_styles_1 = __importDefault(require("./ColorSwatch.styles"));
function ColorSwatch(_a) {
    var _b = _a.component, Element = _b === void 0 ? 'div' : _b, color = _a.color, _c = _a.size, size = _c === void 0 ? 25 : _c, style = _a.style, _d = _a.radius, radius = _d === void 0 ? 25 : _d, className = _a.className, themeOverride = _a.themeOverride, others = __rest(_a, ["component", "color", "size", "style", "radius", "className", "themeOverride"]);
    var classes = ColorSwatch_styles_1.default({ radius: radius, theme: theme_1.useMantineTheme(themeOverride) });
    return (react_1.default.createElement(Element, __assign({ className: clsx_1.default(classes.colorSwatch, className), style: __assign({ width: size, height: size, backgroundColor: color }, style), "data-mantine-composable": true }, others)));
}
exports.ColorSwatch = ColorSwatch;
ColorSwatch.displayName = '@mantine/core/ColorSwatch';
